import http from "./request";
const gwurl="https://gw.chci.cn"
let SSOID= $cookies.get("SSOID")
//商城订单列表
export const getOrderListApi = (searchContent,orderStatus,pageNum,pageSize) => http({
    method: "get",
    url: "/apis/hmcsFinance/v1/shopOrder/list",
    params: {
        searchContent,orderStatus,pageNum,pageSize
    }
})
//商城订单详情
export const getOrderDetailApi = (orderCode) => http({
    method: "get",
    url: "/apis/hmcsFinance/v1/shopOrder/backOrdersDetail",
    params: {
        orderCode
    }
})
// 订单出售
export const  sellApi=(orderCode,userName)=>http({
    method: "post",
    url: "/apis/hmcsFinance/v1/shopOrder/sellProduct",
    params: {
        orderCode,userName
    }
})
// 商城订单-收款确认
export const collectMoneyConfirm = (fordata) => http({
    method: "post",
    url: "/apis/hmcsFinance/v1/shopOrder/collectMoneyConfirm",
    data:new URLSearchParams(fordata)
})